var take = /*#__PURE__*/require("../take.js");
function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}
module.exports = dropLast;